import { getSelectedTableView } from 'owa-mail-list-store';
import { resetFocus } from 'owa-mail-focus-manager';
import type { ActionSource } from 'owa-mail-store';
import { lazyAddSafeSenderFromTable } from 'owa-mail-triage-action';
import getEffectiveRowKeys from 'owa-mail-reading-pane-store/lib/utils/getEffectiveRowKeys';

export default function onNeverBlock(actionSource: ActionSource): void {
    const tableView = getSelectedTableView();
    const rowKeys = getEffectiveRowKeys(tableView);

    lazyAddSafeSenderFromTable.importAndExecute(rowKeys, tableView, actionSource);
    resetFocus('neverBlockCommand');
}
